import { Chip, ChipProps } from '@common-components';
import { SubmissionMethod } from 'enums';
import { MethodsConfig } from './methods-config';

interface SubmissionMethodChipProps
  extends Pick<ChipProps, 'label' | 'disabled' | 'disabledTooltipContent' | 'onClick'> {
  method: SubmissionMethod;
}

export function SubmissionMethodChip({ method, label, disabled, ...chipProps }: SubmissionMethodChipProps) {
  const config = MethodsConfig[method];

  return (
    <Chip
      {...config}
      {...chipProps}
      disabled={disabled}
      {...(label && { label })}
      {...(disabled && { textColor: 'gray.800', iconColor: 'gray.800' })}
    />
  );
}
